import React from 'react';
import { Link, Route } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-danger">
  <Link className="navbar-brand" to="/" refresh="true">Home</Link>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon" />
  </button>
  <div className="collapse navbar-collapse" id="navbarNavDropdown">
    <ul className="navbar-nav">
     
      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Entertainment
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <Link className="dropdown-item" to="/ent1">Ent 1</Link>
          <Link className="dropdown-item" to="/ent2">Ent 2</Link>
          <Link className="dropdown-item" to="/ent3">Ent 3</Link>
        </div>
      </li>
      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Science
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <Link className="dropdown-item" to="/sci1">Sci 1</Link>
          <Link className="dropdown-item" to="/sci2">Sci 2</Link>
          <Link className="dropdown-item" to="/sci3">Sci 3</Link>
        </div>
      </li>
      <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Humanities
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <Link className="dropdown-item" to="/hum1">Hum 1</Link>
          <Link className="dropdown-item" to="/hum2">Hum 2</Link>
          <Link className="dropdown-item" to="/hum3">Hum 3</Link>
        </div>
      </li>
      <li className="nav-item dropdown active">
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          General Knowledge
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <Link className="dropdown-item" to="/gen1">No 1</Link>
          <Link className="dropdown-item" to="/gen2">No 2</Link>
          <Link className="dropdown-item" to="/gen3">No 3</Link>
        </div>
      </li>
      <li className="nav-item dropdown text-right">
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Others
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <Link className="dropdown-item" to="/oth1">Mythology</Link>
          <Link className="dropdown-item" to="/oth2">Art</Link>
          <Link className="dropdown-item" to="/oth3">Books</Link>
        </div>
      </li>
    </ul>
  </div>
  <div className="collapse navbar-collapse flex-grow-0" id="navbarSupportedContent">
        <ul className="navbar-nav text-right">
            <li className="nav-item active">
                <a className="nav-link" href="#">Register</a>
            </li>
            <li className="nav-item active">
                <a className="nav-link" href="#">Login</a>
            </li>
            <li className="nav-item active">
                <a className="nav-link" href="#">Logout</a>
            </li>
        </ul>
    </div>
</nav>

  );
};

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/layout/navbar.jsx